<template>
    <div class="mt-2">
        <v-btn
            @click="$emit('skip')"
            small
            text
        >
            lewati
        </v-btn>

        <v-btn
            @click="$emit('send')"
            :disabled="disabled"
            small
            color="primary"
        >
            kirim
        </v-btn>
    </div>
</template>

<script>
export default {
    props: ['disabled']
}
</script>
